module.exports = __webpack_public_path__ + "img/relogio.6ef84a3e.png";